<template>
  <v-card class="canvas-dialog">
    <v-card-title class="canvas-dialog__close pa-1">
      <v-btn
        text
        icon
        plain
        depressed
        class="ma-0"
        @click="closeDialog"
      >
        <v-icon
          small
        >
          mdi-close-thick
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="canvas-dialog__title canvas-dialog__text pa-0">
      Finalize o carrinho
    </v-card-text>

    <v-card-text
      class="canvas-dialog__text pa-0 pt-3"
    >
      Apresente o QR code abaixo para o cliente e/ou copie o link para enviá-lo.
    </v-card-text>

    <v-card-text class="d-flex justify-center pt-0">
      <canvas
        ref="canvas"
        class="canvas-dialog__canvas"
      />
    </v-card-text>

    <v-card-actions class="canvas-dialog__actions px-0 py-4 ma-0">
      <v-btn
        class="canvas-dialog__btn mb-2"
        medium
        depressed
        color="#140C22"
        dark
        @click="copyCheckoutLink($event.target)"
      >
        <v-icon
          small
          class="mr-2"
        >
          mdi-content-copy
        </v-icon>
        Copiar Link
      </v-btn>
      <v-btn
        id="copyLink"
        class="canvas-dialog__btn ma-0"
        flat
        @click="backToCheckout"
      >
        Voltar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { EventBus } from '../event-bus';
import { mapGetters } from 'vuex';

const QRCode = require('qrcode');

export default {
  name: 'QrCodeDialog',
  props: {
    closeDialog: {
      type: Function,
      default: () => {},
    },
    backToCheckout: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      checkout: null,
    };
  },
  computed: {
    ...mapGetters(['getCheckoutLink']),
  },
  watch: {
    async getCheckoutLink() {
      const { canvas } = this.$refs;
      if (!this.getCheckoutLink) return;

      QRCode.toCanvas(canvas, this.getCheckoutLink, { width: 280 }, (error) => {
        if (error) console.error('err', this.getCheckoutLink, error);
      });
    },
  },
  methods: {
    emitSnackbar(text) {
      const snackBar = {};
      snackBar.value = true;
      snackBar.text = text;
      snackBar.color = '#140C22';
      snackBar.button = false;
      snackBar.icon = '$vuetify.icons.checkIcon';
      snackBar.class = {
        height: '120px',
        'font-size': '16px',
        'font-weight': '600',
        'justify-content': 'center',
      };
      EventBus.$emit('activeSnackBar', snackBar);
    },
    copyCheckoutLink(targetElement) {
      window.Clipboard.copy(this.getCheckoutLink, targetElement);
      this.emitSnackbar('Link copiado com sucesso');
      this.$router.push('/produtos');
    },
  },
};
</script>

<style scoped lang="scss">
.canvas-dialog {
  width: 100%;
  font-family: 'Nunito Sans';
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #140C22;
  text-transform: none;
  border-radius: 7px;
  &__text {
    margin: 0 40px;
    width: fit-content;
  }
  &__actions {
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    height: auto;
  }
  &__btn {
    width: 280px;
    height: 38px;
    border-radius: 7px;
    text-transform: none;
    font-weight: 600;
  }
  &__close {
    display: flex;
    justify-content: end;
  }
  &__title {
    margin-left: 40px;
    font-weight: 700;
    font-size: 20px;
    line-height: 27px;
    color: #140C22;
  }
  &__canvas {
    opacity: 0.8;
  }
}

</style>
